import { render, staticRenderFns } from "./DetailsCourseAssignSubjectTemplateModal.vue?vue&type=template&id=294d4fbe&scoped=true&"
import script from "./DetailsCourseAssignSubjectTemplateModal.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseAssignSubjectTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294d4fbe",
  null
  
)

export default component.exports